
import React, { useState, useEffect, useContext } from "react";
import { RouteComponentProps, withRouter, useLocation } from "react-router-dom";
import { RBButton } from "../../components/RBButton";
import { RBCardView } from "../../components/RBCardView";
import { Font, Spacing } from "../../theme/Theme";
import { IndustryModeEnum, RoutePathConstant, roleNameEnum, getAlgorithm, getEncryptionKey, getEncryptionIV, getEffectiveRoleName, EmptyString, RegistrationStatus } from "../../util/Common";
import CustomButton from "../../components/CustomButton";
import { AuthService } from "../../api/AuthService";
import StatBlock from "../../components/StatBlock";
import { RBContext } from "../../components/RBContext";
import { AlertInfoProps } from "../../interfacesProps/AlertInfoProps";
import { RBAlert } from "../../components/RBAlert";
import { ShiftService } from "../../api/ShiftService";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import crypto from 'crypto';
import { LoadingIndicator } from "../../components/LoadingIndicator";
import { AccountInfoContext } from "../../components/AccountInfoContext";
const useStyles = makeStyles({
  root: {
    minWidth: 275,
    display: "flex",
    flex: 1,
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  sectionHeader: {
    fontSize: Font.larger, fontWeight:"bold",
    //  backgroundColor: "red",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  CardContent: {
    display: "flex",
    flex: 1,
    flexDirection: "row",
  },
});

interface DashboardPageWithoutRouteProps extends RouteComponentProps<any> {
  roleName: string;
  userName: string;
}

const DashboardPageWithoutRoute: React.FC<DashboardPageWithoutRouteProps> = ({
  history,
  ...props
}) => {
  const { userName } = props;
  const location = useLocation();
  const { accountInformation } = useContext(AccountInfoContext);
  const [roleName, setRoleName] = useState<string>("");
  const { industryMode,primaryColor,secondaryColor,updateprimaryColor,updateSecondaryColor,updateContactEmail,updateContactPhone,updateMode  } = useContext(RBContext);

  const [alertInfo, setAlertInfo] = useState<AlertInfoProps>({});
  const [isAlertShowing, setAlertShowing] = useState(false);
  const [account, setAccount] = useState<any>([]);
  const [complete, setComplete] = useState<any>(null);
  const [upcoming, setUpcoming] = useState<any>(null);
  const [requestReceived, setRequestReceived] = useState<any>(null);
  const [unassigned, setUnassigned] = useState<any>(null);
  const [isLocationLoading, setIsLocationLoading] = useState(false);
  const classes = useStyles();
  const isRegionalManager = roleName === roleNameEnum.regionalmanager;
  const effectiveRoleName = getEffectiveRoleName(account, roleName);
  const isOwnerLike =
    effectiveRoleName === roleNameEnum.owner || isRegionalManager;

  const invalidAccountStates = ['pending', 'denied'];

  useEffect(() => {
    (async () => {
      await updateprimaryColor(localStorage.getItem('primaryColor'));
      await updateSecondaryColor(localStorage.getItem('secondaryColor'));
      await updateContactEmail(localStorage.getItem('contactEmail'));
      await updateContactPhone(localStorage.getItem('contactPhone'));
      await updateMode(localStorage.getItem('industryMode'));
    })();

    setRoleName(AuthService.getRoleName());
  }, []);

  useEffect(() => {
    const handleRegionalManagerLocationChange = async () => {
      setIsLocationLoading(true);
      try {
        await fetchUserData();
      } finally {
        setIsLocationLoading(false);
      }
    };

    window.addEventListener(
      "regional-manager-location-changed",
      handleRegionalManagerLocationChange
    );

    return () => {
      window.removeEventListener(
        "regional-manager-location-changed",
        handleRegionalManagerLocationChange
      );
    };
  }, []);
  
  const isUserPending = (userData:any) => {
    if (!userData) {
      return false;
    }

    if (userData.owner) {
      return (
        invalidAccountStates.indexOf(userData.owner.approval?.status) >= 0
      );
    }

    if (userData.pharmacist) {
      return (
        invalidAccountStates.indexOf(userData.pharmacist.approval?.status) >=
        0
      );
    }

    return false;
  };
   const getUserAccountStatus = (userData:any) => {
    if (!userData) {
      return 'approved';
    }

    if (userData.owner) {
      return userData.owner.approval?.status;
    }
    if (userData.pharmacist) {
      return userData.pharmacist.approval?.status;
    }
    return 'approved';
  };

  const fetchUserData = async () => {

    if (!accountInformation) {
      return;
    }

    // A signed-in user who hasn't finished registration (e.g. arriving from the
    // verify-email link) has no profile to show yet, so send them to the account
    // creation modal instead.
    if (accountInformation.registrationStatus === RegistrationStatus.PreRegistered) {
      history.replace(RoutePathConstant.PendingRegistration);
      return;
    }

    if (
      AuthService.getRoleName() === roleNameEnum.regionalmanager &&
      !localStorage.getItem("regionalManagerSelectedUserId")
    ) {
      history.push(RoutePathConstant.RegionalManagerDashboard);
      return;
    }
    if (isUserPending(accountInformation)) {
      history.push(RoutePathConstant.PendingApproval + (getUserAccountStatus(accountInformation)));

    }
    setAccount(accountInformation);
    if(getEffectiveRoleName(accountInformation, roleName) === roleNameEnum.owner){
      const stripeData = await AuthService.getStripeDetails(accountInformation.networks[0].id);
      if(stripeData.data !== undefined)
      {
        const algorithm = getAlgorithm();
        const encryptionKey = getEncryptionKey();
        const IV = getEncryptionIV();
        const encryptionKeyBuffer = Buffer.from(encryptionKey, 'hex');
        const ivBuffer = Buffer.from(IV, 'hex');

        const decipher = crypto.createDecipheriv(algorithm, encryptionKeyBuffer, ivBuffer);
        let decryptedData = decipher.update(stripeData.data.pubKey, 'hex', 'utf8');
        decryptedData += decipher.final('utf8');
        console.log("decryptedData", decryptedData)
        //const stripePromise = loadStripe(decryptedData);
        localStorage.setItem('stripePromise',decryptedData)
      }
    }
    await fetchStatus()
  }

  const fetchStatus = async () => {
    const account = accountInformation;

    if (!account) {
      return;
    } 

    let pharmacy = null;
    if (account.pharmacies) {
      pharmacy = account.pharmacies.filter((pharmacy:any) => pharmacy.id === account.owner.defaultPharmacyId)[0];
      let statDetails = await AuthService.fetchLocationStats(pharmacy.id);
      setComplete(statDetails?.totalShiftCompleted !== null && statDetails?.totalShiftCompleted !== undefined ? statDetails?.totalShiftCompleted : 0);
      setUnassigned(statDetails?.totalUnassignedShifts !== null && statDetails?.totalUnassignedShifts !== undefined ? statDetails?.totalUnassignedShifts : 0);
      setRequestReceived(statDetails?.activeShiftRequests !== null && statDetails?.activeShiftRequests !== undefined ? statDetails?.activeShiftRequests : 0);
    } else {
      pharmacy = { networkId: account.networks[0].id };
      let statDetails = await AuthService.fetchWorkerStats(account.id);

      setComplete(statDetails.totalShiftCompleted !== null && statDetails.totalShiftCompleted !== undefined? statDetails.totalShiftCompleted : 0);
      setUpcoming(statDetails.totalUpcomingShifts !== null && statDetails.totalUpcomingShifts !== undefined ? statDetails.totalUpcomingShifts : 0);
      setRequestReceived(statDetails.activeShiftRequests !== null && statDetails.activeShiftRequests !== undefined ? statDetails.activeShiftRequests : 0);
    }
  }

  // Run the full dashboard data load whenever accountInformation becomes available.
  // It is fetched asynchronously in AccountInfoContext and is typically null on the
  // first render of this component, so fetchUserData (which also calls fetchStatus)
  // has to run here rather than only on mount.
  useEffect(() => {
    if (accountInformation && Object.keys(accountInformation).length > 0) {
      fetchUserData();
    }
  }, [accountInformation]);

  const getWelcomeLabel = () => {
    if (isRegionalManager) {
      return localStorage.getItem("regionalManagerSelectedLocationTitle") || EmptyString;
    }

    if (effectiveRoleName === roleNameEnum.owner) {
      return (
        account?.pharmacies?.find(
          (pharmacy: any) => pharmacy.id === account?.owner?.defaultPharmacyId
        )?.name || localStorage.getItem("pharmacyName") || EmptyString
      );
    }

    return localStorage.getItem("firstName") || EmptyString;
  };

  
  const onShiftCreatePressed = async () => {

    if (industryMode === IndustryModeEnum.Dentistry || industryMode === IndustryModeEnum.Labour) {
      return onShiftCreatePressedForDentalOffice();
    }
    if(isOwnerLike)
    {
        history.push(RoutePathConstant.CreateShift)
    }
    else{
      history.push(RoutePathConstant.SearchShifts)
     
    }

  };
  const onShiftCreatePressedForDentalOffice = () => {
    
    if(isOwnerLike)
    {
        history.push(RoutePathConstant.CreateDentalShift)
    }
    else{
      history.push(RoutePathConstant.SearchShifts)
     
    }
  };

  const onJobCreatePressed = () => {
    if (industryMode === IndustryModeEnum.Dentistry || industryMode === IndustryModeEnum.Labour) {
      return onJobCreatePressedForDentalOffice();
    }
    
    if(isOwnerLike)
    {
        history.push(RoutePathConstant.CreateJob)
    }
    else{
      history.push(RoutePathConstant.SearchJobs)
     
    }
  };

  const onJobCreatePressedForDentalOffice = () => {
    if(isOwnerLike)
    {
        history.push(RoutePathConstant.CreateDentalJob)
    }
    else{
      history.push(RoutePathConstant.SearchJobs)
     
    }
  }




  const renderOwnerButtons = () => {
    return (
      <>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <span style={{ marginLeft: 158, marginTop: 21 }}>
          {/* <span style={{ marginLeft: 320, marginTop: 21 }}> */}
            <CustomButton
              text="POST SHIFT"
              style={{
                backgroundImage: `linear-gradient(60deg, #bec0ce, ${primaryColor} )`,
              }}
              onClick={() => onShiftCreatePressed()}
            />
          </span>
          <span style={{ marginLeft: 292, marginTop: 21 }}>
            <CustomButton
              text="POST JOB"
              style={{
                backgroundImage: `linear-gradient(120deg, #c5d8d8, ${secondaryColor})`,
                border: "2px solid rgba(170, 211, 213, 1)",
              }}
              onClick={() => onJobCreatePressed()}
            />
          </span>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <span style={{
            marginLeft: 95,
            marginTop: 245
          }}>
            <StatBlock
              loading={complete === null}
              value={complete}
              title="shifts"
              subtitle="completed"
            />
          </span >
          <span style={{
            marginTop: 245
          }}>
            <StatBlock
              loading={unassigned === null}
              value={unassigned}
              title="shifts"
              subtitle="unfilled"
            />
          </span>
          <span style={{
            marginTop: 245
          }}>
            <StatBlock
              loading={requestReceived === null}
              value={requestReceived}
              title="shifts"
              subtitle="requested"
            />
          </span>
        </div>
      </>
    );
  };

  const renderWorkerButtons = () => {
    return (
      <>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <span style={{ marginLeft: 158, marginTop: 21 }}>
            <CustomButton
              text="FIND SHIFT"
              style={{
                backgroundImage: `linear-gradient(60deg, #bec0ce, ${primaryColor})`,
              }}
              onClick={() => onShiftCreatePressed()}
            />
          </span>
          <span style={{ marginLeft: 292, marginTop: 21 }}>
            <CustomButton
              text="FIND JOB"
              style={{
                backgroundImage: `linear-gradient(120deg, #c5d8d8, ${secondaryColor})`,
                border: "2px solid rgba(170, 211, 213, 1)",
              }}
              onClick={() => onJobCreatePressed()}
            />
          </span>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <span style={{
            marginLeft: 95,
            marginTop: 245
          }}>
            <StatBlock
              loading={complete === null}
              value={complete}
              title="shifts"
              subtitle="completed"
            />
          </span >
          <span style={{
            marginTop: 245
          }}>
            <StatBlock
              loading={upcoming === null}
              value={upcoming}
              title="shifts"
              subtitle="upcoming"
            />
          </span>
          <span style={{
            marginTop: 245
          }}>
            <StatBlock
              loading={requestReceived === null}
              value={requestReceived}
              title="shifts"
              subtitle="applied"
            />
          </span>
        </div>

      </>

    );
  };

  return (
    <RBCardView
      style={{
        flex: 1,
        margin: Spacing.large,
        padding: Spacing.large,
      }}
    >

      <RBAlert
        show={isAlertShowing}
        alertTitle={alertInfo.title}
        alertMessage={alertInfo.message}
        buttons={alertInfo.buttons}
      />

      {isLocationLoading ? (
        <div
          style={{
            minHeight: 420,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <LoadingIndicator />
        </div>
      ) : (
        <>
          <div
            className={classes.sectionHeader}
            color="primary"
            style={{
              textAlign:"center"
            }}
          >
            {`Welcome back ${getWelcomeLabel()}!`}
          </div>
          <br></br>

          {isOwnerLike ? renderOwnerButtons() : renderWorkerButtons()}
        </>
      )}
    </RBCardView>
  );
};

export const DashboardPage = withRouter(DashboardPageWithoutRoute);
